/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import {
    DialogContentText as BaseDialogContentText,
    DialogContentTextProps,
} from "@mui/material";

// Das SCSS des DialogContentText muss in der App importiert werden
export default function DialogContentText(props: DialogContentTextProps) {
    return (
        <BaseDialogContentText
            {...props}
            className={`lan-dialogcontenttext ${props.className ?? ""}`.trim()}
        />
    );
}
